"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 21. 2. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var AdtFlag_1 = require("../AdtFlag");

var FlagSet_1 = require("../FlagSet");
/**
 * Base class for flags on {@link ValidationResultObject validation result objects}.
 * @author Radek Beran
 */


var ValidationResultFlag =
/*#__PURE__*/
function (_AdtFlag_1$AdtFlag) {
  _inherits(ValidationResultFlag, _AdtFlag_1$AdtFlag);

  function ValidationResultFlag() {
    _classCallCheck(this, ValidationResultFlag);

    return _possibleConstructorReturn(this, _getPrototypeOf(ValidationResultFlag).apply(this, arguments));
  }

  _createClass(ValidationResultFlag, null, [{
    key: "register",
    value: function register(ctor, tag) {
      return AdtFlag_1.AdtFlag.registerBase(ValidationResultFlag, ctor, tag);
    }
  }, {
    key: "deserialize",
    value: function deserialize(data) {
      return AdtFlag_1.AdtFlag.deserializeBase(ValidationResultFlag, data);
    }
  }]);

  return ValidationResultFlag;
}(AdtFlag_1.AdtFlag);

exports.ValidationResultFlag = ValidationResultFlag;
ValidationResultFlag.TAG = '__ValidationResultFlag__';
ValidationResultFlag.EMPTY_SET = FlagSet_1.FlagSet.of(ValidationResultFlag); // do not declare specific flags here, use specific application module